import { alpha } from '@mui/material';
import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => {
  return {
    root: {
      '& .MuiDialog-paper': {
        backgroundColor: (theme) => theme.palette.shade?.[50],
        backgroundImage: 'none',
        maxWidth: '75vw',
        maxHeight: '75vh',
      },
    },
    actionsButtonContainer: {
      display: 'flex',
      gap: '10px',
      justifyContent: 'flex-end',
      width: '100%',
      padding: '1rem 0',
    },
    dialogHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '1rem',
    },
    closeButton: {
      width: 'fit-content',
      alignSelf: 'flex-end',
    },
    iconContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    },
    iconBox: {
      height: 60,
      width: 60,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      color: (theme) => theme.palette.info.main,
      backgroundColor: (theme) => alpha(theme.palette.info.main, 0.3),
      '.MuiSvgIcon-root': {
        fontSize: '3rem',
      },
    },
    filters: {
      display: 'flex',
      gap: (theme) => theme.spacing(2),
    },
    searchInput: {
      marginLeft: 'auto',
    },
    tableRow: {
      '&:hover .MuiTableCell-root': {
        backgroundColor: (theme) => theme.palette.shade?.[300],
      },
    },
  };
};

export default useSx;
